import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "src/store";

export interface IdeviceLogs {
  deviceLogsFilter: {
    fingerprint: string;
    dateGte: string;
    dateLte: string;
  };
}

const initialState: IdeviceLogs = {
  deviceLogsFilter: {
    fingerprint: "",
    dateGte: "",
    dateLte: "",
  },
};

type deviceLogsFilter = {
  fingerprint?: string;
  dateGte?: string;
  dateLte?: string;
};

export const deviceLogsFilterSlice = createSlice({
  name: "thisDeviceLogsFilter",
  initialState,
  reducers: {
    setDeviceLogsFilter: (state, action: PayloadAction<deviceLogsFilter>) => {
      state.deviceLogsFilter = {
        ...state.deviceLogsFilter,
        ...action.payload,
      };
    },
    reset: () => {
      return initialState;
    },
  },
});

export const { setDeviceLogsFilter } = deviceLogsFilterSlice.actions;

export const getDeviceLogsFilter = (state: RootState) =>
  state.thisDeviceLogsFilter.deviceLogsFilter;

export default deviceLogsFilterSlice.reducer;
